import { graphql, useStaticQuery } from "gatsby";

export type IAssetsData = {
  allWpAssets: {
    nodes: {
      title: string;
      uri: string;
      date: string;
      assetsInfo: {
        fileLabel: string;
        file: {
          mimeType: string;
          localFile: {
            publicURL: string;
          };
        };
      };
    }[];
  };
};

const useAssetsData = () => {
  const { allWpAssets }: IAssetsData = useStaticQuery(graphql`
    {
      allWpAssets(sort: { date: DESC }) {
        nodes {
          title
          uri
          date(formatString: "D MMM YYYY")

          assetsInfo {
            fileLabel
            file {
              mimeType
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  `);

  return allWpAssets.nodes;
};

export default useAssetsData;
